import React from "react";
import { Link } from "react-router-dom";


function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="company-info">
          <p>회사명: 주식회사 워크웨이 | 대표자: 채주연</p>
          <p>연락처: 010-4260-3693</p>
          <p>
            문의 메일:{" "}
            <a href="mailto:hms@workway.co.kr">hms@workway.co.kr</a>
          </p>
          <p>주소: 서울특별시 영등포구 국회대로36길 6-1 (당산동3가), 2층-제이15호 (07257)</p>
          <p>사업자등록번호: 169-86-03431</p>
        </div>
        <div className="copyright-info">
          <p>&copy; 2024 주식회사 워크웨이. All rights reserved.</p>
          <div className="footer-links mt-2">
            <Link to="/refund-policy" className="text-gray-500 hover:text-blue-600 underline">취소 및 환불 규정</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
